import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckFolder = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 13,
	height: 11,
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fill: "#167248",
			d: "M12 1.788H6.39L4.559.034A.13.13 0 0 0 4.472 0H.5a.5.5 0 0 0-.5.5v9.25a.5.5 0 0 0 .5.5H12a.5.5 0 0 0 .5-.5V2.288a.5.5 0 0 0-.5-.5m-.625 7.337H1.125v-8H4.07l1.87 1.788h5.435z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#167248",
			d: "M5.294 6.947 4.05 5.704l-.424.42 1.668 1.668 3.58-3.58-.421-.42z"
		})
	]
});
const ForwardRef = forwardRef(SvgCheckFolder);
export { ForwardRef as ReactComponent };
